export const statusCodes = {
    ACCEPTED: 'accepted',
    FAILURE: 'failure',
    SUCCESS: 'success',
};
